import { StyleSheet, View } from 'react-native';
import { AlertTriangle, BookmarkPlus, RefreshCw } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppButton } from '../ui/AppButton';
import { AppText } from '../ui/AppText';

type PhotoSearchResultActionsProps = {
  savedToWrongBook: boolean;
  savingToWrongBook: boolean;
  onMarkHelpful: () => void;
  onAddToWrongBook: () => void;
  onReportAnswerIssue: () => void;
  onRetry: () => void;
};

export function PhotoSearchResultActions({
  savedToWrongBook,
  savingToWrongBook,
  onMarkHelpful,
  onAddToWrongBook,
  onReportAnswerIssue,
  onRetry,
}: PhotoSearchResultActionsProps) {
  return (
    <View style={styles.wrapper}>
      <AppText variant="caption" tone="muted">
        AI 讲解仅供学习参考，如发现错误请反馈。
      </AppText>
      <View style={styles.row}>
        <AppButton
          label={savedToWrongBook ? '已加入错题本' : '加入错题本'}
          disabled={savedToWrongBook}
          loading={savingToWrongBook}
          onPress={onAddToWrongBook}
          leftSlot={<BookmarkPlus size={16} color={tokens.colors.white} />}
          style={styles.primaryAction}
        />
      </View>
      <View style={styles.row}>
        <AppButton
          label="满意"
          variant="secondary"
          onPress={onMarkHelpful}
          style={styles.secondaryAction}
        />
        <AppButton
          label="不满意"
          variant="secondary"
          onPress={onReportAnswerIssue}
          leftSlot={<AlertTriangle size={16} color={tokens.colors.primary} />}
          style={styles.secondaryAction}
        />
        <AppButton
          label="重新生成"
          variant="secondary"
          onPress={onRetry}
          leftSlot={<RefreshCw size={16} color={tokens.colors.primary} />}
          style={styles.secondaryAction}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    gap: tokens.spacing.md,
    marginTop: tokens.spacing.sm,
  },
  row: {
    flexDirection: 'row',
    gap: tokens.spacing.md,
  },
  primaryAction: {
    flex: 1,
  },
  secondaryAction: {
    flex: 1,
  },
});
